import React from 'react';
import { connect } from 'react-redux';
import { getDocumentCategories } from '~/src/api/content/document-categories';
import * as base from '~/src/helpers/basePageFunc';
import Layout from '~/src/layout/_layout';
import SectionDocument from '~/src/components/Document/SectionDocument';

const DocumentPage = ({ city, hostname, documents }) => {

    return (
        <Layout
            title={`Документы - Дом.ру в ${city.cityIn}`}
            description={`Все необходимые документы от Дом.ру в ${city.cityIn}`}
            hostname={hostname}
            relCanonical={`https://${hostname}/service/document`}
            withMenu
            withFooter
            withChat
        >
            <SectionDocument title='Документы' items={documents} />
        </Layout>
    );
};

DocumentPage.getInitialProps = async options => {
    const { hostname } = await base.initialProps(options);
    const { store } = options;
    const documents = await getDocumentCategories(store.getState().city.currentCity.domain);
    return { hostname, documents };
};

const mapState = state => ({
    city: state.city.currentCity,
    cities: state.city.citiesList
});

export default connect(mapState)(DocumentPage);
